module.exports = __webpack_public_path__ + "static/img/05046C_2_C_20210308_fit.235b49e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/05046C_2_C_20210308_fit.png
// module id = oqJZ
// module chunks = 0